@if (gone()) {
  <!-- Every step done and the celebration finished; nothing left to show. -->
} @else if (loading()) {
  <umss-skeleton variant="Object" />
} @else if (allCompleted()) {
  <div class="setup-card completion" [class.completion--fading]="fading()">
    <umss-card variant="Default" padding="None" borderRadius="Large">
      <div class="completion__inner">
        <div class="confetti-container" aria-hidden="true">
          @for (piece of confettiPieces; track piece) {
            <div class="confetti" [style.--delay]="piece * 0.1 + 's'"></div>
          }
        </div>

        <div class="completion__content">
          <div class="completion__header">
            <umss-icon
              name="phosphorCheckCircle"
              size="20px"
              color="var(--green-500)"
            />
            <h3 class="completion__title">{{ completionTitle() }}</h3>
          </div>
          @if (completionMessage()) {
            <p class="completion__message">{{ completionMessage() }}</p>
          }
        </div>
      </div>
    </umss-card>
  </div>
} @else {
  <div class="setup-card">
    <umss-card variant="Default" padding="None" borderRadius="Large" gap="None">
      <!-- On desktop the detail view replaces the whole card, header included. -->
      @if (!isDesktop() || !showDetail()) {
        <button
          type="button"
          class="card-header"
          [class.card-header--static]="isDesktop()"
          [attr.aria-expanded]="isDesktop() ? null : sheetOpen()"
          [disabled]="isDesktop()"
          (click)="onHeaderClick()"
        >
          <umss-progress-ring [value]="progressPercent()" [size]="40" />

          <span class="card-header__info">
            <span class="card-header__title">{{ title() }}</span>
            <span class="card-header__count">
              {{ completedCount() }} of {{ totalCount() }} complete
            </span>
          </span>

          @if (!isDesktop()) {
            <umss-icon
              class="card-header__chevron"
              [class.card-header__chevron--up]="sheetOpen()"
              name="phosphorCaretDown"
              size="20px"
              color="var(--color-text-text-secondary)"
            />
          }
        </button>
      }

      @if (isDesktop()) {
        <div class="card-body" [class.card-body--detail]="showDetail()">
          <ng-container [ngTemplateOutlet]="body" />
        </div>
      }
    </umss-card>
  </div>

  <umss-dialog
    [open]="sheetOpen()"
    type="BottomSheet"
    size="Full"
    [showHeader]="false"
    [showFooter]="false"
    [showHandle]="false"
    (onClose)="onSheetClose()"
  >
    <div class="sheet">
      @if (!showDetail()) {
        <div class="sheet__header">
          <button
            type="button"
            class="sheet__collapse"
            aria-label="Collapse"
            (click)="onSheetClose()"
          >
            <umss-icon
              name="phosphorCaretDown"
              size="24px"
              color="var(--color-text-text-secondary)"
            />
          </button>

          <div class="sheet__progress">
            <umss-progress-ring [value]="progressPercent()" [size]="40" />
            <div class="card-header__info">
              <h2 class="card-header__title">{{ title() }}</h2>
              <span class="card-header__count">
                {{ completedCount() }} of {{ totalCount() }} complete
              </span>
            </div>
          </div>
        </div>
      }

      <ng-container [ngTemplateOutlet]="body" />
    </div>
  </umss-dialog>
}

<!-- Rendered into whichever container is live, never both at once. -->
<ng-template #body>
  @if (showDetail()) {
    <ng-container
      [ngTemplateOutlet]="detailTemplate()!"
      [ngTemplateOutletContext]="{ $implicit: activeStep()! }"
    />
  } @else {
    @if (description()) {
      <p class="card-body__description" [class.card-body__description--attention]="attention()">
        @if (attention()) {
          <umss-icon name="phosphorWarning" size="16px" color="var(--amber-600)" />
        }
        <span>{{ description() }}</span>
      </p>
    }

    <div class="card-body__steps">
      @for (step of steps(); track step.id) {
        <umss-setup-step [step]="step" (stepClick)="onStepClick($event)" />
      }
    </div>
  }
</ng-template>
